<div mat-dialog-content style="border-radius: 25px;" *ngIf="!isMobile()">
  <h2 class="main-heading">
    Start your journey with Inforida now!
  </h2>
  <form class="example-form">
    <table class="example-full-width" cellspacing="0">
      <tr>
        <td style="width:50%;">
          <mat-form-field class=" example-full-width" appearance="outline">
            <mat-label>Enter your name</mat-label>
            <input matInput [(ngModel)]="formData.name" #nameWeb="ngModel" minlength="5" maxlength="30" type="text"
              required [ngModelOptions]="{standalone: true}">
            <mat-error *ngIf="formData.name.length<1">Name is required</mat-error>
            <mat-error *ngIf="nameWeb.invalid && formData.name.length>0">
              Name is not valid
            </mat-error>
          </mat-form-field>
        </td>
        <td>
        </td>
      </tr>
    </table>
    <table class="example-full-width" cellspacing="0">
      <tr>
        <td>
          <mat-form-field class="example-full-width" appearance="outline">
            <mat-label>Enter your mobile no</mat-label>
            <input matInput [(ngModel)]="formData.mobile" #mobileWeb="ngModel" type="text" maxlength="10" minlength="10"
              required [ngModelOptions]="{standalone: true}">
            <mat-hint align="end">{{formData.mobile.length}}/10</mat-hint>
            <mat-error *ngIf="formData.mobile.length<1">Mobile no is required</mat-error>
            <mat-error *ngIf="mobileWeb.invalid && formData.mobile.length>0">
              Mobile number is not valid
            </mat-error>
          </mat-form-field>
        </td>
        <td>
          <mat-form-field class="example-full-width" appearance="outline">
            <mat-label>Enter your email id</mat-label>
            <input matInput [(ngModel)]="formData.email" #emailWeb="ngModel" maxlength="60" minlength="5" type="email"
              [ngModelOptions]="{standalone: true}">
            <mat-error *ngIf="formData.email.length<1">Email id is required</mat-error>
            <mat-error *ngIf="emailWeb.invalid && formData.email.length>0">
              Email id is not valid
            </mat-error>
          </mat-form-field>
        </td>
      </tr>
    </table>
    <table class="example-full-width" cellspacing="0">
      <tr>
        <td>
          <mat-form-field class="example-full-width" appearance="outline">
            <mat-label>Enter Institute Name</mat-label>
            <input matInput value="" [(ngModel)]="formData.organizationName" [ngModelOptions]="{standalone: true}"
              maxlength="100" minlength="10" #organizationNameWeb="ngModel" required>
            <mat-error *ngIf="formData.organizationName.length<1">Institute Name is required</mat-error>
            <mat-error *ngIf="organizationNameWeb.invalid  && formData.organizationName.length>0">
              Institute name is not valid.
            </mat-error>
          </mat-form-field>
        </td>
      </tr>
    </table>
    <table class="example-full-width" cellspacing="0">
      <tr>
        <td>
          <mat-form-field class="example-full-width" appearance="outline">
            <mat-label>Enter number of students</mat-label>
            <input matInput [(ngModel)]="formData.totalStudents" [ngModelOptions]="{standalone: true}" type="number"
              max="50000" #totalStudentsWeb="ngModel" required>
            <mat-error *ngIf="totalStudentsWeb.invalid">
              Total students is not valid.
            </mat-error>
          </mat-form-field>
        </td>
        <td>
          <mat-form-field class="example-full-width" appearance="outline">
            <mat-label>Enter city name</mat-label>
            <input matInput [(ngModel)]="formData.city" #cityWeb="ngModel" minlength="2" maxlength="100"
              [ngModelOptions]="{standalone: true}" required>
            <mat-error *ngIf="formData.city.length<1">City name is required</mat-error>
            <mat-error *ngIf="cityWeb.invalid && formData.city.length>0">
              City name is not valid.
            </mat-error>
          </mat-form-field>
        </td>
      </tr>
    </table>
    <table class="example-full-width" cellspacing="0">
      <tr>
        <td>
          <h3>How soon you want to integrate Inforida to your ecosystem?</h3>
          <mat-radio-group color="accent" [(ngModel)]="formData.days" [ngModelOptions]="{standalone: true}">
            <mat-radio-button class="radio" value="7" style="margin-right: 30px;">In 7 days</mat-radio-button>
            <mat-radio-button value="30" class="radio" style="margin-right: 30px;">In 30 days</mat-radio-button>
          </mat-radio-group>
        </td>
      </tr>
    </table>
    <table style="text-align: center;">
      <button (click)="submitDetails()" mat-raised-button class="btn-get" color="primary" mat-dialog-close>Submit
        details</button>
    </table>
  </form>
</div>

<div mat-dialog-content style="border-radius: 25px;" *ngIf="isMobile()">
  <h2 class="main-heading">
    Start your journey!
  </h2>
  <form class="example-form">
    <table class="" cellspacing="0">
      <tr>
        <td class="single-feild">
          <mat-form-field class="example-full-width" appearance="outline">
            <mat-label>Enter your name</mat-label>
            <input matInput [(ngModel)]="formData.name" #nameWeb="ngModel" minlength="5" maxlength="30" type="text"
              required [ngModelOptions]="{standalone: true}">
            <mat-error *ngIf="formData.name.length<1">Name is required</mat-error>
            <mat-error *ngIf="nameWeb.invalid && formData.name.length>0">
              Name is not valid
            </mat-error>
          </mat-form-field>
        </td>
        <!-- <td>
        </td> -->
      </tr>
      <!-- </table>
    <table class="example-full-width" cellspacing="0"> -->
      <tr>
        <td>
          <mat-form-field class="example-full-width" appearance="outline">
            <mat-label>Enter your mobile no</mat-label>
            <input matInput [(ngModel)]="formData.mobile" #mobileWeb="ngModel" type="text" maxlength="10" minlength="10"
              required [ngModelOptions]="{standalone: true}">
            <mat-hint align="end">{{formData.mobile.length}}/10</mat-hint>
            <mat-error *ngIf="formData.mobile.length<1">Mobile no is required</mat-error>
            <mat-error *ngIf="mobileWeb.invalid && formData.mobile.length>0">
              Mobile number is not valid
            </mat-error>
          </mat-form-field>
        </td>
      </tr>
      <tr>
        <td>
          <mat-form-field class="example-full-width" appearance="outline">
            <mat-label>Enter your email id</mat-label>
            <input matInput [(ngModel)]="formData.email" #emailWeb="ngModel" maxlength="60" minlength="5" type="email"
              [ngModelOptions]="{standalone: true}">
            <mat-error *ngIf="formData.email.length<1">Email id is required</mat-error>
            <mat-error *ngIf="emailWeb.invalid && formData.email.length>0">
              Email id is not valid
            </mat-error>
          </mat-form-field>
        </td>
      </tr>
      <!-- </table> -->
      <tr>
        <td>
          <mat-form-field class="example-full-width" appearance="outline">
            <mat-label>Enter Institute Name</mat-label>
            <input matInput value="" [(ngModel)]="formData.organizationName" [ngModelOptions]="{standalone: true}"
              maxlength="100" minlength="10" #organizationNameWeb="ngModel" required>
            <mat-error *ngIf="formData.organizationName.length<1">Institute Name is required</mat-error>
            <mat-error *ngIf="organizationNameWeb.invalid  && formData.organizationName.length>0">
              Institute name is not valid.
            </mat-error>
          </mat-form-field>
        </td>
      </tr>
      <!-- <table class="example-full-width" cellspacing="0"> -->
      <tr>
        <td>
          <mat-form-field class="example-full-width" appearance="outline">
            <mat-label>Enter number of students</mat-label>
            <input matInput [(ngModel)]="formData.totalStudents" [ngModelOptions]="{standalone: true}" type="number"
              max="50000" #totalStudentsWeb="ngModel" required>
            <mat-error *ngIf="totalStudentsWeb.invalid">
              Total students is not valid.
            </mat-error>
          </mat-form-field>
        </td>
      </tr>
      <tr>
        <td>
          <mat-form-field class="example-full-width" appearance="outline">
            <mat-label>Enter city name</mat-label>
            <input matInput [(ngModel)]="formData.city" #cityWeb="ngModel" minlength="2" maxlength="100"
              [ngModelOptions]="{standalone: true}" required>
            <mat-error *ngIf="formData.city.length<1">City name is required</mat-error>
            <mat-error *ngIf="cityWeb.invalid && formData.city.length>0">
              City name is not valid.
            </mat-error>
          </mat-form-field>
        </td>
      </tr>
      <tr>
        <td>
          <h3>How soon you want to integrate Inforida to your ecosystem?</h3>
          <mat-radio-group [(ngModel)]="formData.days" [ngModelOptions]="{standalone: true}">
            <mat-radio-button class="radio" value="7" style="margin-right: 30px;">In 7 days</mat-radio-button>
            <mat-radio-button value="30" class="radio" style="margin-right: 30px;">In 30 days</mat-radio-button>
          </mat-radio-group>
        </td>
      </tr>
    </table>
    <div style="text-align: center;">
      <button mat-raised-button (click)="submitDetails()" class="btn-get" color="primary" mat-dialog-close>Submit
        details</button>
    </div>
  </form>
</div>
